import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { CONTACT } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
export function WhatsAppButton() {
  const {
    t
  } = useLanguage();
  return <a href={CONTACT.whatsappHref} target="_blank" rel="noreferrer" aria-label={t.whatsapp.aria} className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-whatsapp text-white shadow-xl transition-[transform,background-color] duration-200 ease-out hover:scale-105 hover:bg-[#1DB456] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-whatsapp sm:h-16 sm:w-16" data-id="element-211" data-mp="271wpduqf7cqk">
      <MessageCircleIcon className="h-7 w-7 sm:h-8 sm:w-8" aria-hidden="true" data-id="element-212" data-mp="1jddoi09pa28i" />
    </a>;
}